<script setup>
import AppFooter from "./components/layout/app-footer.vue";
import AppHeader from "./components/layout/app-header.vue";
import { sizes, subscribe, unsubscribe } from "./helpers/screen/media-query";
import { reactive, onMounted, onBeforeUnmount, computed } from "vue";
import { useRoute } from 'vue-router';
import { RouteNames } from '@/router/RouteNames';

const route = useRoute();

const getScreenSizeInfo = () => {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
  };
}

const screen = reactive({ getScreenSizeInfo: {} });
screen.getScreenSizeInfo = getScreenSizeInfo();

function screenSizeChanged() {
  screen.getScreenSizeInfo = getScreenSizeInfo();
}

onMounted(async () => {

  subscribe(screenSizeChanged);
});

onBeforeUnmount(() => {
  unsubscribe(screenSizeChanged);
});

const cssClasses = computed(() => {
  return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
});

</script>
<template>
  <div id="root">
    <div :class="cssClasses">
      <header class="sticky-header">
        <app-header />
      </header>
      <section class="content">
        <router-view></router-view>
      </section>
      <footer v-if="route.path === `/${RouteNames.Home}`">
        <app-footer></app-footer>
      </footer>
    </div>
  </div>
</template>
<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

header {
  width: 100%;
  position: sticky !important;
  top: 0px;
  background-color: white;
  z-index: 10;
}

footer {
  max-width: 26.8rem;
  margin-top: auto;
}

@media only screen and (min-width: 480px) {
  footer {
    width: 375px;
    max-width: 26.8rem;
  }
}


.app {
  @import "./themes/generated/variables.base.scss";
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Lato';
  font-weight: 400;
  font-style: normal;
  background: url('@/components/logos/background-property-logo.png') no-repeat center right fixed;
}

.content {
  width: 100%;
  padding: 17px;
  max-width: 26.8rem;
  min-height: 60vh;

}
</style>
